import { render, staticRenderFns } from "./ModuleSlide.vue?vue&type=template&id=5c00966f&"
import script from "./ModuleSlide.vue?vue&type=script&lang=js&"
export * from "./ModuleSlide.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSlide.vue?vue&type=style&index=0&id=5c00966f&prod&lang=scss&"
import style1 from "./ModuleSlide.vue?vue&type=style&index=1&id=5c00966f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports